import React, {Component} from 'react';
import mixitup from 'mixitup';

const jQuery = window.jQuery,
	$ = jQuery;

class Mixitup extends Component {

	componentDidMount() {
		this.$node = $(this.refs.mixtable);
		mixitup(this.$node, {});
	}

	render() {
		const {id = `MixItUp${new Date().getTime()}`, children, className} = this.props;
		return (
			<div ref="mixtable" id={id} className={["mixitup", className].join(' ')}>
				{children}
			</div>
		)
	}
}

export default Mixitup;



// WEBPACK FOOTER //
// ./src/components/containers/Mixitup.js